import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useBadgeSmithCheckoutFlag() {
  return useCbhFlag(CbhFeatureFlag.CONFIGURE_BADGE_SMITH_CHECKOUT, {
    defaultValue: { enabled: false as const },
  });
}
